import React, { forwardRef } from "react";
import { formatToTitleCase } from "../../../../Utils/utils";
import { colorMapping } from "../TagDropdown/constants";

export default forwardRef(function Tag(
  { tag, toggleDropdown, shouldRender },
  ref
) {
  const isDarkFontColor = tag === "yellow" || !tag;

  return (
    <button
      ref={ref}
      className={`upload-panel__tag ${
        shouldRender ? "" : "upload-panel__tag--hidden"
      }`}
      onClick={toggleDropdown}
      style={{
        backgroundColor: colorMapping[tag],
        color: isDarkFontColor ? "black" : "white",
        fontWeight: tag === "yellow" ? 600 : "",
      }}
    >
      <span>{tag ? formatToTitleCase(tag) : "+ Add tag"}</span>
    </button>
  );
});



// WEBPACK FOOTER //
// ./src/components/UploadPanel/components/Tag/index.js